import { getTopologyState, groupUnitsByStatus } from "@/store/flowsheet/flowsheet.slice"
import { CloseCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons"
import { Space, Badge } from "antd"
import { useMemo } from "react"
import { useSelector } from "react-redux"

export const SimulationStatus = ({onClick}: {onClick: () => void}) => {
  const simState = useSelector(getTopologyState)

  const errorGroups = useMemo(() => {
    if (!simState || !simState.operations) return {
      errors: [],
      warnings: [],
      succeds: []
    }
    return groupUnitsByStatus(simState.operations)
  }, [simState])
  return <Space onClick={onClick} style={{cursor: 'pointer'}}>
    <Badge count={errorGroups.errors.length}>
      <CloseCircleOutlined style={{color: 'red', fontSize: 16}} />
    </Badge>
    <Badge count={errorGroups.warnings.length} className="ml-1">
      <ExclamationCircleOutlined style={{color: '#f2b202', fontSize: 16}} />
    </Badge>
  </Space>
}